"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDocumentAuditValidationComparisonsDto = instanceOfDocumentAuditValidationComparisonsDto;
exports.DocumentAuditValidationComparisonsDtoFromJSON = DocumentAuditValidationComparisonsDtoFromJSON;
exports.DocumentAuditValidationComparisonsDtoFromJSONTyped = DocumentAuditValidationComparisonsDtoFromJSONTyped;
exports.DocumentAuditValidationComparisonsDtoToJSON = DocumentAuditValidationComparisonsDtoToJSON;
exports.DocumentAuditValidationComparisonsDtoToJSONTyped = DocumentAuditValidationComparisonsDtoToJSONTyped;
const DocumentAuditVaccinationComparisonDto_1 = require("./DocumentAuditVaccinationComparisonDto");
const DocumentAuditNameComparisonDto_1 = require("./DocumentAuditNameComparisonDto");
const DocumentAuditCertificationComparisonDto_1 = require("./DocumentAuditCertificationComparisonDto");
/**
 * Check if a given object implements the DocumentAuditValidationComparisonsDto interface.
 */
function instanceOfDocumentAuditValidationComparisonsDto(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
function DocumentAuditValidationComparisonsDtoFromJSON(json) {
    return DocumentAuditValidationComparisonsDtoFromJSONTyped(json, false);
}
function DocumentAuditValidationComparisonsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': (0, DocumentAuditNameComparisonDto_1.DocumentAuditNameComparisonDtoFromJSON)(json['name']),
        'vaccinations': json['vaccinations'] == null ? undefined : (json['vaccinations'].map(DocumentAuditVaccinationComparisonDto_1.DocumentAuditVaccinationComparisonDtoFromJSON)),
        'certifications': json['certifications'] == null ? undefined : (json['certifications'].map(DocumentAuditCertificationComparisonDto_1.DocumentAuditCertificationComparisonDtoFromJSON)),
    };
}
function DocumentAuditValidationComparisonsDtoToJSON(json) {
    return DocumentAuditValidationComparisonsDtoToJSONTyped(json, false);
}
function DocumentAuditValidationComparisonsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': (0, DocumentAuditNameComparisonDto_1.DocumentAuditNameComparisonDtoToJSON)(value['name']),
        'vaccinations': value['vaccinations'] == null ? undefined : (value['vaccinations'].map(DocumentAuditVaccinationComparisonDto_1.DocumentAuditVaccinationComparisonDtoToJSON)),
        'certifications': value['certifications'] == null ? undefined : (value['certifications'].map(DocumentAuditCertificationComparisonDto_1.DocumentAuditCertificationComparisonDtoToJSON)),
    };
}
//# sourceMappingURL=DocumentAuditValidationComparisonsDto.js.map